"use client";

import Echo from "laravel-echo";
import Pusher from "pusher-js";

/**
 * Lazily-initialised, browser-only Laravel Echo client pointed at our
 * self-hosted Reverb server (free, Pusher-protocol compatible).
 *
 * Lazy + window-guarded so it never runs during SSR/prerender (Echo touches
 * `window`). Memoised so the whole app shares one WebSocket connection.
 */
let echoInstance: Echo<"reverb"> | null = null;

export function getEcho(): Echo<"reverb"> {
    if (typeof window === "undefined") {
        throw new Error("getEcho() must only be called in the browser");
    }

    if (!echoInstance) {
        // laravel-echo's Pusher connector reads the global Pusher.
        (window as unknown as { Pusher: typeof Pusher }).Pusher = Pusher;

        echoInstance = new Echo({
            broadcaster: "reverb",
            key: process.env.NEXT_PUBLIC_REVERB_APP_KEY,
            wsHost: process.env.NEXT_PUBLIC_REVERB_HOST,
            wsPort: Number(process.env.NEXT_PUBLIC_REVERB_PORT ?? 8080),
            wssPort: Number(process.env.NEXT_PUBLIC_REVERB_PORT ?? 8080),
            forceTLS: (process.env.NEXT_PUBLIC_REVERB_SCHEME ?? "http") === "https",
            enabledTransports: ["ws", "wss"],
        });
    }

    return echoInstance;
}
